import { render, staticRenderFns } from "./searchList.vue?vue&type=template&id=208242bc&scoped=true"
import script from "./searchList.vue?vue&type=script&lang=js"
export * from "./searchList.vue?vue&type=script&lang=js"
import style0 from "./searchList.vue?vue&type=style&index=0&id=208242bc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "208242bc",
  null
  
)

export default component.exports